﻿import {Core} from "../Base/Core";
import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";
import {Time} from "../Utils/Unity/Time";

export class TapChallengeResult {
    IsWin = false;
    Score = 0;
    TargetScore = 0;
    TimeSpent = 0;
    IsReplay = false;
}

export class TapChallengeMode extends MonoBehaviour {

    get IsFinished() {
        return this._isFinished
    };

    get IsActive() {
        return this._isActive
    };

    get IsInProgress() {
        return this._isInProgress && this._isActive
    };

    get TimeRemains() {
        if (this.IsFinished) return 0;
        return this._duration - (Time.time - this._timeStart);
    }

    get CurrentScore() {
        return this._currentScore;
    }

    set CurrentScore(value) {
        this._currentScore = value;
        this.emit("ScoreUpdated", value);
    }

    get TargetScore() {
        return this._targetScore
    };

    Awake() {
        this._isFinished = false;
        this._isActive = false;
        this._isInProgress = false;
        this._duration = 20;
        this._isReplay = false;
        this._currentScore = 0;
        this._targetScore = 0;
        this._timeStart = 0;
        this._settings = Core.GameData.TapChallenge; // TapChallenge
    }

    AddScore(score) {
        this.CurrentScore++;
        if (this.CurrentScore >= this._targetScore) {
            this.StopChallenge(true);
        }
    }

    GetScoreProgress() {
        return this.CurrentScore / this._targetScore;
    }

    GetTimeProgress() {
        return this.TimeRemains / this._duration;
    }

    ActivateChallenge() {
        this._isActive = true;
        this.emit("Activated", true);
    }

    DisableChallenge() {
        this._isActive = false;
        this.emit("Activated", false);
    }

    StartChallenge(data, isReplay = false) {
        this._isReplay = !!isReplay;
        if (this._isReplay) {
            this.CurrentScore = data.Score;
            this._targetScore = data.TargetScore;
            this._duration = this._settings.additionalTime;
        } else {
            this.CurrentScore = 0;
            this._targetScore = this._settings.baseClickCount
                + data.challengesWinedCount * this._settings.victoryDurationIncrease
                - data.challengesLostCount * this._settings.lostDurationDecrease
            ;
            this._targetScore = Math.max(this._settings.baseClickCount, Math.min(this._settings.maxClickAmount, this._targetScore));
            this._duration = this._settings.duration;
        }
        this.RunChallengeTimer();
        this.emit("Started");
    }

    PauseChallenge() {
        this._isInProgress = !this._isInProgress;
        return this._isInProgress;
    }

    Update() {
        // count time and points
        if (this._isInProgress) {
            if (this.GetTimeProgress() <= 0) {
                this.StopChallenge(false);
            }
        }
    }

    StopChallenge(isWin) {
        let oldIsFinished = this._isFinished;
        this._isFinished = true;
        this._isInProgress = false;
        if (!oldIsFinished) {
            let result = Object.assign(new TapChallengeResult(), {
                IsWin: isWin,
                Score: this.CurrentScore,
                TargetScore: this._targetScore,
                TimeSpent: this._settings.duration - (Time.time - this._timeStart),
                IsReplay: this._isReplay
            });
            console.log("TAP CHALLENGE RESULT", isWin, result);
            this.emit("Finished", result);
        }
    }

    RunChallengeTimer() {
        if (!this._isReplay) {
            this._currentScore = 0;
        }
        this._isFinished = false;
        this._isInProgress = true;
        this._timeStart = Time.time;
    }
}
